import { render, staticRenderFns } from "./pushSettings.vue?vue&type=template&id=d55ce640&scoped=true"
import script from "./pushSettings.vue?vue&type=script&lang=js"
export * from "./pushSettings.vue?vue&type=script&lang=js"
import style0 from "./pushSettings.vue?vue&type=style&index=0&id=d55ce640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55ce640",
  null
  
)

export default component.exports